export default __webpack_public_path__ + "static/media/O-041.d1f50faa.png";